import React from 'react';
import logo from './logo.png';

const HomeSection = ({ onNavigate }) => (
  <section className="section home-section" id="home">
    <div className="hero-backdrop" aria-hidden="true" />
    <div className="hero-grid">
      <div className="hero-copy">
        <div className="eyebrow"><span /> Nationwide freight solutions</div>
        <img className="hero-logo" src={logo} alt="GOS Trans" />
        <h1>Your cargo.<br /><em>Our commitment.</em></h1>
        <p>
          Reliable freight transportation, real-time coordination and dedicated
          service that keeps your business moving.
        </p>
        <div className="hero-actions">
          <a className="button button-primary" href="/contact" onClick={event => onNavigate(event, 'contact')}>
            Get in touch <span aria-hidden="true">→</span>
          </a>
          <a className="button button-ghost" href="/services" onClick={event => onNavigate(event, 'services')}>
            Explore services
          </a>
        </div>
        <div className="hero-trust">
          <div><strong>48</strong><span>States covered</span></div>
          <div><strong>24/7</strong><span>Dispatch support</span></div>
          <div><strong>100%</strong><span>Committed</span></div>
        </div>
      </div>
    </div>
    <div className="scroll-hint" aria-hidden="true"><span /> Scroll to explore</div>
  </section>
);

export default HomeSection; 